import script from "./baseComponent.vue?vue&type=script&lang=ts"
export * from "./baseComponent.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__